import { useTranslate } from 'core/hooks/useTranslate';
import { InputCheckbox } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';

function TreeViewToSelectLabel({ getChecked, isSelectable, item, onChange }) {
  const { t } = useTranslate();
  return (
    <div className="tree-view-to-select-label">
      <div className="tree-view-to-select-label__checked">
        {isSelectable ? (
          <InputCheckbox
            disabled={item.isDisabled}
            checked={getChecked(item)}
            onChange={() => onChange(item)}
            label={t(`learning_objectives:${item.name}`, { defaultValue: item.name })}
            subtitle={item.description}
          />
        ) : (
          <div className="tree-view-to-select-label__text">
            <span className="title">{t(`learning_objectives:${item.name}`, { defaultValue: item.name })}</span>
            <span className="description">{item.description}</span>
          </div>
        )}
      </div>
    </div>
  );
}

TreeViewToSelectLabel.propTypes = {
  getChecked: PropTypes.func,
  isSelectable: PropTypes.bool,
  item: PropTypes.object,
  onChange: PropTypes.func,
};

export default TreeViewToSelectLabel;
